import React from 'react'
import { Box } from 'pcln-design-system'
import { Modal } from 'pcln-modal'
import Form from '../SearchForm/Form'
import { handleSubmitForExpressDeals } from '../SearchForm/utils'
import StyledHeading from '../../StyledHeading'
import useExpressDealModal from '../../CustomHooks/useExpressDealModal'
import { ANALYTICS_CATEGORY_HOTELS } from '../../../constants/analytics'
import { PromoDeal } from '../constants'

const PRIMARY_HEADING_TEXT = 'Search for Express Deal®'
const SECONDARY_HEADING_TEXT =
  'Save up to 60% Fast and Easy - No Bidding Required!'

export default function ExpressDealModal({
  isModalOpen,
  gaCategory = ANALYTICS_CATEGORY_HOTELS,
  qsKey = 'modal',
  qsValue = 'express-deals'
}: {
  isModalOpen: boolean
  gaCategory?: string
  qsKey?: string
  qsValue?: string
}) {
  const { closeModal } = useExpressDealModal(qsKey, qsValue)

  return (
    <Modal
      enableOverflow
      ariaLabel="Express Deals Search Modal"
      isOpen={isModalOpen}
      onClose={closeModal}
      timeout={50}
      width={[1, 750]}
    >
      <Box p={[3, 0]}>
        <Box px={[0, 3]}>
          <StyledHeading
            aceContent={['SITE-X.HOMEPAGE.SEARCHAREA.EXPRESSDEALS.TITLE']}
            fontSize={[3, null, null, 5]}
            lineHeight="1.25"
            tag="h1"
            text={PRIMARY_HEADING_TEXT}
          />
          <StyledHeading
            fontSize={[1, null, null, 4]}
            mb={3}
            lineHeight="1.25"
            tag="h2"
            text={SECONDARY_HEADING_TEXT}
          />
        </Box>
        <Box pb={4} px={[0, 3]}>
          <Form
            onSubmit={values =>
              handleSubmitForExpressDeals({ ...values, gaCategory })
            }
            promoDeal={PromoDeal.EXPRESS_DEAL}
          />
        </Box>
      </Box>
    </Modal>
  )
}
